import { useState } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Orbitron:wght@400;600;700;900&display=swap');

  .cert-section {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 4rem 80px;
    font-family: 'Rajdhani', sans-serif;
  }

  .cert-container {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
  }

  .cert-header {
    text-align: center;
    margin-bottom: 4rem;
  }

  .cert-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    color: #ff8c00;
    letter-spacing: 5px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1rem;
    opacity: 0;
    animation: certFadeUp 0.7s ease 0.1s both;
  }
  .cert-label::before, .cert-label::after { content: ''; width: 50px; height: 1px; }
  .cert-label::before { background: linear-gradient(to right, transparent, #ff8c00); }
  .cert-label::after  { background: linear-gradient(to left,  transparent, #ff8c00); }

  .cert-title {
    font-family: 'Orbitron', monospace;
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    font-weight: 900;
    background: linear-gradient(135deg, #ffffff 0%, #38c8ff 60%, #00aaff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 20px rgba(0,170,255,0.3));
    opacity: 0;
    animation: certFadeUp 0.7s ease 0.2s both;
  }

  /* GRID */
  .cert-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
    gap: 1.5rem;
    opacity: 0;
    animation: certFadeUp 0.7s ease 0.3s both;
  }

  .cert-card {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.12);
    border-top: 2px solid #00aaff;
    padding: 1.6rem;
    position: relative;
    transition: all 0.3s;
    cursor: pointer;
  }

  .cert-card:hover {
    border-color: rgba(0,170,255,0.35);
    box-shadow: 0 0 25px rgba(0,170,255,0.1);
    transform: translateY(-4px);
  }

  .cert-card::before {
    content: '';
    position: absolute;
    top: -2px; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(to right, #00aaff, transparent);
  }

  .cert-card-top {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .cert-icon-wrap {
    width: 42px;
    height: 42px;
    background: rgba(0,170,255,0.08);
    border: 1px solid rgba(0,170,255,0.22);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    flex-shrink: 0;
  }

  .cert-info {}

  .cert-name {
    font-family: 'Orbitron', monospace;
    font-size: 0.75rem;
    font-weight: 700;
    color: #e8f4ff;
    margin-bottom: 0.25rem;
    line-height: 1.35;
  }

  .cert-organizer {
    font-size: 0.85rem;
    color: #00aaff;
    font-weight: 600;
  }

  .cert-date {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    color: #4a7a9b;
    letter-spacing: 1px;
    margin-top: 0.2rem;
  }

  .cert-divider {
    height: 1px;
    background: linear-gradient(to right, rgba(0,170,255,0.2), transparent);
    margin: 0.8rem 0;
  }

  .cert-type-tag {
    display: inline-block;
    background: rgba(0,170,255,0.06);
    border: 1px solid rgba(0,170,255,0.18);
    border-radius: 3px;
    padding: 0.2rem 0.65rem;
    font-family: 'Orbitron', monospace;
    font-size: 0.55rem;
    color: #4a7a9b;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-right: 0.4rem;
  }

  .cert-preview-hint {
    font-size: 0.78rem;
    color: rgba(0,170,255,0.5);
    margin-top: 0.8rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  /* MODAL */
  .cert-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(2,8,16,0.9);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    backdrop-filter: blur(8px);
    animation: overlayIn 0.25s ease both;
  }

  .cert-modal {
    background: rgba(0, 20, 50, 0.97);
    border: 1px solid rgba(0,170,255,0.3);
    border-top: 2px solid #00aaff;
    padding: 2.5rem;
    max-width: 560px;
    width: 100%;
    position: relative;
    animation: modalIn 0.3s ease both;
  }

  .cert-modal::before {
    content: '';
    position: absolute;
    top: -2px; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(to right, #00aaff, transparent);
  }

  .cert-modal-close {
    position: absolute;
    top: 1rem; right: 1rem;
    background: rgba(0,170,255,0.08);
    border: 1px solid rgba(0,170,255,0.2);
    color: #00aaff;
    font-size: 1rem;
    width: 32px; height: 32px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    font-family: 'Orbitron', monospace;
    transition: all 0.3s;
  }

  .cert-modal-close:hover {
    background: rgba(0,170,255,0.2);
    border-color: rgba(0,170,255,0.5);
  }

  .cert-modal-title {
    font-family: 'Orbitron', monospace;
    font-size: 0.95rem;
    font-weight: 700;
    color: #e8f4ff;
    margin-bottom: 0.5rem;
    padding-right: 2rem;
    line-height: 1.4;
  }

  .cert-modal-org {
    font-size: 0.9rem;
    color: #00aaff;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }

  .cert-modal-date {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    color: #4a7a9b;
    letter-spacing: 1px;
    margin-bottom: 1.5rem;
  }

  .cert-preview-box {
    width: 100%;
    height: 200px;
    background: rgba(0,170,255,0.04);
    border: 1px dashed rgba(0,170,255,0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .cert-preview-icon-lg {
    font-size: 3rem;
    opacity: 0.4;
  }

  .cert-preview-placeholder {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    color: #4a7a9b;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  @keyframes certFadeUp {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @keyframes overlayIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes modalIn {
    from { opacity: 0; transform: scale(0.95) translateY(20px); }
    to   { opacity: 1; transform: scale(1) translateY(0); }
  }

  @media (max-width: 900px) {
    .cert-section { padding: 100px 2rem 60px; }
    .cert-grid { grid-template-columns: 1fr; }
  }
`;

const CERTIFICATES = [  
  {
    icon: "🔌",
    name: "3rd Annual Conference of the CIDR: Connect. Innovate. Design. Revolutionize.",
    organizer: "Center for Integrated Circuit and Device Research",
    date: "August 2025",
    type: "Conference",
    image: "/certs/1.png",
  },
  {
    icon: "⚙️",
    name: "Arduino Workshop: Integration of Hardware",
    organizer: "FAITH Computer Engineering Society",
    date: "September 2025",
    type: "Workshop",    
    image: "/certs/Certificate of Participation - Manalo (1).PNG",
  },
  {
    icon: "🚀",
    name: "Engineering the Future: Career Stories and Industry Insights",
    organizer: "FAITH Colleges - College of Engineering",
    date: "March 2025",
    type: "Seminar",    
    image: "/certs/MANALO, VINCENT.png",
  },
  {
    icon: "📂",
    name: "Backend Development Foundations: From Concepts to Practice",
    organizer: "ICpEP.se - FAITH Chapter",
    date: "March 2026",
    type: "Workshop",
    image: "/certs/backend.png",
  },
  {
    icon: "🏆",
    name: "CpElympics 2026: Game Changers",
    organizer: "ICpEP R4A - Student Edition",
    date: "March 2026",
    type: "Participants - Basketball Mens",
    image: "/certs/IMG_20260417_091524.jpg",
  },
];

export default function Certificates() {
  const [selected, setSelected] = useState(null);

  return (
    <section className="cert-section" id="certificates">
      <style>{styles}</style>
      <div className="cert-container">

        <div className="cert-header">
          <p className="cert-label">Trainings & Certifications</p>
          <h2 className="cert-title">Certificates / Seminars</h2>
        </div>

        <div className="cert-grid">
          {CERTIFICATES.map((c, i) => (
            <div
              className="cert-card"
              key={i}
              onClick={() => setSelected(c)}
            >
              <div className="cert-card-top">
                <div className="cert-icon-wrap">{c.icon}</div>
                <div className="cert-info">
                  <p className="cert-name">{c.name}</p>
                  <p className="cert-organizer">{c.organizer}</p>
                  <p className="cert-date">{c.date}</p>
                </div>
              </div>
              <div className="cert-divider" />
              <span className="cert-type-tag">{c.type}</span>
              <p className="cert-preview-hint">🔍 Click to preview</p>
            </div>
          ))}
        </div>

        {/* Modal */}
        {selected && (
          <div className="cert-modal-overlay" onClick={() => setSelected(null)}>
            <div className="cert-modal" onClick={(e) => e.stopPropagation()}>
              <button className="cert-modal-close" onClick={() => setSelected(null)}>✕</button>
              <p className="cert-modal-title">{selected.name}</p>
              <p className="cert-modal-org">{selected.organizer}</p>
              <p className="cert-modal-date">{selected.date} · {selected.type}</p>
              
              {/* ITO 'YUNG BINAGO NATIN: Dinagdag 'yung <img> tag */}
              <div className="cert-preview-box" style={{ height: 'auto', minHeight: '200px', overflow: 'hidden' }}>
                {selected.image ? (
                  <img 
                    src={selected.image} 
                    alt={selected.name} 
                    style={{ 
                      width: '100%', 
                      height: 'auto', 
                      display: 'block',
                      borderRadius: '2px'
                    }} 
                  />
                ) : (
                  <>
                    <span className="cert-preview-icon-lg">{selected.icon}</span>
                    <p className="cert-preview-placeholder">Certificate Preview</p>
                    <p style={{ fontSize: '0.75rem', color: 'rgba(232,244,255,0.3)', textAlign: 'center', padding: '0 1rem' }}>
                      No image uploaded yet
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

      </div>
    </section>
  );
}